<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学术管理</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{
          path: '/academic_Management/academic_font_management/academic_referee_system',
        }"
        >裁判系统</el-breadcrumb-item
      >
      <el-breadcrumb-item>裁判席管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>

    <!-- 条件筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">条件筛选</span>
        </el-col>
      </el-row>
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                v-model="queryForm.season"
                placeholder="请选择赛季"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                v-model="queryForm.raceSchedule"
                placeholder="请选择赛程"
                style="width: 100%"
                clearable
              >
                <el-option label="全国半决选" :value="17"></el-option>
                <el-option label="全国总决选" :value="18"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="考场" prop="roomName">
              <el-select
                v-model="queryForm.roomName"
                placeholder="请选择考场"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in roomOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button type="primary" style="width: 100%" @click="searchData"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>

    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="5">
          <span class="title_class">裁判席列表</span>
        </el-col>
        <el-col :span="19" style="text-align: right">
          <el-button type="primary" @click="addClicked">新增裁判席+</el-button>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="tableData"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column
          label="赛季"
          prop="season"
          :formatter="seasonFormatter"
        ></el-table-column>
        <el-table-column
          label="赛程"
          prop="raceSchedule"
          :formatter="raceScheduleFormatter"
        ></el-table-column>
        <el-table-column label="考场" prop="roomName"></el-table-column>
        <el-table-column label="总控">
          <template slot-scope="scope">
            <div v-if="scope.row.director" style="display: flex; align-items: center;">
              <el-image
                v-if="scope.row.directorUrl"
                :src="scope.row.directorUrl"
                :preview-src-list="[scope.row.directorUrl]"
                style="width: 40px; height: 40px; border-radius: 4px; margin-right: 8px;"
                fit="cover"
              ></el-image>
              <span>{{ scope.row.director }}</span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="中方">
          <template slot-scope="scope">
            <div v-if="scope.row.judge" style="display: flex; align-items: center;">
              <el-image
                v-if="scope.row.judgeUrl"
                :src="scope.row.judgeUrl"
                :preview-src-list="[scope.row.judgeUrl]"
                style="width: 40px; height: 40px; border-radius: 4px; margin-right: 8px;"
                fit="cover"
              ></el-image>
              <span>{{ scope.row.judge }}</span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="发音官">
          <template slot-scope="scope">
            <div v-if="scope.row.pronouncer" style="display: flex; align-items: center;">
              <el-image
                v-if="scope.row.pronouncerUrl"
                :src="scope.row.pronouncerUrl"
                :preview-src-list="[scope.row.pronouncerUrl]"
                style="width: 40px; height: 40px; border-radius: 4px; margin-right: 8px;"
                fit="cover"
              ></el-image>
              <span>{{ scope.row.pronouncer }}</span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="计时员">
          <template slot-scope="scope">
            <div v-if="scope.row.recorder" style="display: flex; align-items: center;">
              <el-image
                v-if="scope.row.recorderUrl"
                :src="scope.row.recorderUrl"
                :preview-src-list="[scope.row.recorderUrl]"
                style="width: 40px; height: 40px; border-radius: 4px; margin-right: 8px;"
                fit="cover"
              ></el-image>
              <span>{{ scope.row.recorder }}</span>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              size="mini"
              @click="editClicked(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              size="mini"
              style="color: #f56c6c"
              @click="deleteClicked(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="isEdit ? '编辑裁判席' : '新增裁判席'"
      :visible.sync="dialogVisible"
      width="1000px"
      @close="dialogClose"
    >
      <el-form
        :model="form"
        label-width="60px"
        ref="formRef"
        :rules="formRules"
        style="width: 100%"
      >
        <el-row :gutter="10">
          <!-- 赛季 -->
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                v-model="form.season"
                placeholder="请选择赛季"
                style="width: 100%"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 赛程 -->
          <el-col :span="8">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                v-model="form.raceSchedule"
                placeholder="请选择赛程"
                style="width: 100%"
              >
                <el-option label="全国半决选" :value="17"></el-option>
                <el-option label="全国总决选" :value="18"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 考场 -->
          <el-col :span="8">
            <el-form-item label="考场" prop="roomName">
              <el-select
                v-model="form.roomName"
                placeholder="请选择考场"
                style="width: 100%"
              >
                <el-option
                  v-for="item in roomOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 总控 -->
          <el-col :span="6">
            <el-form-item label="总控" prop="director">
              <el-input
                v-model="form.director"
                placeholder="请输入总控姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 中方 -->
          <el-col :span="6">
            <el-form-item label="中方" prop="judge">
              <el-input
                v-model="form.judge"
                placeholder="请输入中方姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 发音官 -->
          <el-col :span="6">
            <el-form-item label="发音官" prop="pronouncer">
              <el-input
                v-model="form.pronouncer"
                placeholder="请输入发音官姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 计时员 -->
          <el-col :span="6">
            <el-form-item label="计时员" prop="recorder">
              <el-input
                v-model="form.recorder"
                placeholder="请输入计时员姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="头像">
              <div style="display: flex; align-items: center;">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadUrl"
                  :headers="headerObj"
                  :data="{ filePath: 'itso/teamFile/referee/avatar' }"
                  :show-file-list="false"
                  :on-success="(res) => handleAvatarSuccess(res, 'director')"
                  :before-upload="beforeUpload"
                >
                  <el-image
                    v-if="form.directorUrl"
                    :src="form.directorUrl"
                    style="width: 80px; height: 80px; border-radius: 4px;"
                    fit="cover"
                  ></el-image>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button
                  v-if="form.directorUrl"
                  type="text"
                  style="margin-left: 10px; color: #f56c6c;"
                  @click="form.directorUrl = ''"
                >删除</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="头像">
              <div style="display: flex; align-items: center;">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadUrl"
                  :headers="headerObj"
                  :data="{ filePath: 'itso/teamFile/referee/avatar' }"
                  :show-file-list="false"
                  :on-success="(res) => handleAvatarSuccess(res, 'judge')"
                  :before-upload="beforeUpload"
                >
                  <el-image
                    v-if="form.judgeUrl"
                    :src="form.judgeUrl"
                    style="width: 80px; height: 80px; border-radius: 4px;"
                    fit="cover"
                  ></el-image>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button
                  v-if="form.judgeUrl"
                  type="text"
                  style="margin-left: 10px; color: #f56c6c;"
                  @click="form.judgeUrl = ''"
                >删除</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="头像">
              <div style="display: flex; align-items: center;">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadUrl"
                  :headers="headerObj"
                  :data="{ filePath: 'itso/teamFile/referee/avatar' }"
                  :show-file-list="false"
                  :on-success="(res) => handleAvatarSuccess(res, 'pronouncer')"
                  :before-upload="beforeUpload"
                >
                  <el-image
                    v-if="form.pronouncerUrl"
                    :src="form.pronouncerUrl"
                    style="width: 80px; height: 80px; border-radius: 4px;"
                    fit="cover"
                  ></el-image>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button
                  v-if="form.pronouncerUrl"
                  type="text"
                  style="margin-left: 10px; color: #f56c6c;"
                  @click="form.pronouncerUrl = ''"
                >删除</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="头像">
              <div style="display: flex; align-items: center;">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadUrl"
                  :headers="headerObj"
                  :data="{ filePath: 'itso/teamFile/referee/avatar' }"
                  :show-file-list="false"
                  :on-success="(res) => handleAvatarSuccess(res, 'recorder')"
                  :before-upload="beforeUpload"
                >
                  <el-image
                    v-if="form.recorderUrl"
                    :src="form.recorderUrl"
                    style="width: 80px; height: 80px; border-radius: 4px;"
                    fit="cover"
                  ></el-image>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button
                  v-if="form.recorderUrl"
                  type="text"
                  style="margin-left: 10px; color: #f56c6c;"
                  @click="form.recorderUrl = ''"
                >删除</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  itsoRefereeBoothList,
  itsoRefereeBoothSave,
  itsoRefereeBoothEdit,
  itsoRefereeBoothDelete
} from '@/http/api'

export default {
  data () {
    return {
      isEdit: false,
      dialogVisible: false,
      tableData: [],
      total: 0,
      // 考场下拉选项 ROOM1-ROOM10 + 闭幕式
      roomOptions: [
        { label: 'ROOM1', value: 'ROOM1' },
        { label: 'ROOM2', value: 'ROOM2' },
        { label: 'ROOM3', value: 'ROOM3' },
        { label: 'ROOM4', value: 'ROOM4' },
        { label: 'ROOM5', value: 'ROOM5' },
        { label: 'ROOM6', value: 'ROOM6' },
        { label: 'ROOM7', value: 'ROOM7' },
        { label: 'ROOM8', value: 'ROOM8' },
        { label: 'ROOM9', value: 'ROOM9' },
        { label: 'ROOM10', value: 'ROOM10' },
        { label: '闭幕式', value: '闭幕式' }
      ],
      // 上传配置
      uploadUrl: this.$http.defaults.baseURL + 'upload/uploadFileAliOss',
      headerObj: {
        Authorization: localStorage.getItem('Authorization')
      },
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        season: '',
        raceSchedule: '',
        roomName: ''
      },
      form: {
        id: null,
        director: '',
        directorUrl: '',
        judge: '',
        judgeUrl: '',
        pronouncer: '',
        pronouncerUrl: '',
        recorder: '',
        recorderUrl: '',
        roomName: '',
        season: '',
        raceSchedule: ''
      },
      formRules: {
        // director: [{ required: true, message: '请输入总控姓名', trigger: 'blur' }],
        // judge: [{ required: true, message: '请输入中方姓名', trigger: 'blur' }],
        // pronouncer: [{ required: true, message: '请输入发音官姓名', trigger: 'blur' }],
        // recorder: [{ required: true, message: '请输入计时员姓名', trigger: 'blur' }],
        roomName: [{ required: true, message: '请选择考场', trigger: 'change' }],
        season: [{ required: true, message: '请选择赛季', trigger: 'change' }],
        raceSchedule: [{ required: true, message: '请选择赛程', trigger: 'change' }]
      },
      dict_season: []
    }
  },
  created () {
    this.getSeasonData()
    this.getList()
    // 默认选中当前赛季
    this.queryForm.season = this.$chnEngStatusCode.itsoDefaultSeason
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getSeasonData () {
      this.$userInfo
        .getDataList(this, 't_season', this.$store.state.flag)
        .then((value) => {
          this.dict_season = value
        })
    },
    getList () {
      itsoRefereeBoothList(this.queryForm)
        .then((res) => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    searchData () {
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10
      this.getList()
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.searchData()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getList()
    },
    addClicked () {
      this.isEdit = false
      this.form = {
        director: '',
        directorUrl: '',
        judge: '',
        judgeUrl: '',
        pronouncer: '',
        pronouncerUrl: '',
        recorder: '',
        recorderUrl: '',
        roomName: '',
        season: this.$chnEngStatusCode.itsoDefaultSeason,
        raceSchedule: ''
      }
      this.dialogVisible = true
    },
    editClicked (row) {
      this.isEdit = true
      this.form = { ...row }
      this.dialogVisible = true
    },
    deleteClicked (rowId) {
      this.$confirm('是否确认删除该裁判席?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          itsoRefereeBoothDelete({ id: rowId })
            .then(() => {
              this.$message.success('删除成功')
              this.getList()
            })
            .catch((err) => {
              console.log('err', err)
            })
        })
        .catch(() => {})
    },
    dialogClose () {
      this.isEdit = false
      this.$refs.formRef.resetFields()
    },
    // 头像上传成功
    handleAvatarSuccess (res, type) {
      if (res.code === 200) {
        const url = res.data.url || res.data
        this.form[type + 'Url'] = url
        this.$message.success('上传成功')
      } else {
        this.$message.error('上传失败')
      }
    },
    // 上传前校验
    beforeUpload (file) {
      const isImage = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'].includes(file.type)
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('只能上传jpg/jpeg/png/webp格式图片!')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB!')
        return false
      }
      return true
    },
    submitForm () {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        if (this.isEdit) {
          itsoRefereeBoothEdit(this.form)
            .then(() => {
              this.$message.success('修改成功')
              this.dialogVisible = false
              this.getList()
            })
            .catch((err) => {
              console.log('err', err)
            })
        } else {
          itsoRefereeBoothSave(this.form)
            .then(() => {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.getList()
            })
            .catch((err) => {
              console.log('err', err)
            })
        }
      })
    },
    seasonFormatter (row) {
      if (!row.season) return '--'
      let label = row.season
      for (let i = 0; i < this.dict_season.length; i++) {
        if (this.dict_season[i].dictValue === row.season) {
          label = this.dict_season[i].dictLabel
          break
        }
      }
      return label
    },
    raceScheduleFormatter (row) {
      if (row.raceSchedule === '17') return '全国半决选'
      if (row.raceSchedule === '18') return '全国总决选'
      return '--'
    }
  }
}
</script>

<style scoped>
.avatar-uploader {
  display: inline-block;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
}
.avatar-uploader-icon:hover {
  border-color: #409EFF;
}
</style>
